import { FC, useRef, useState } from 'react'
import classNames from 'classnames'
import useOutsideClick from 'src/hooks/useOutsideClick'
import { AdPerfAccount } from 'src/services/adPerformanceApi'
import s from './dashboard.module.scss'
import { CheckIcon, ChevronDown } from './icons'

interface Props {
  accounts: AdPerfAccount[]
  onChange: (accountId: string) => void
  value: string
}

const Avatar: FC<{ name: string }> = ({ name }) => (
  <span className={s.accountAvatar}>{name.trim()[0]?.toUpperCase()}</span>
)

// "D  Digital Shop / Ad account ID: …  ⌄" from the design.
export const AccountPicker: FC<Props> = ({ accounts, onChange, value }) => {
  const ref = useRef<HTMLDivElement>(null)
  const [open, setOpen] = useState(false)
  useOutsideClick({ onOutsideClick: () => setOpen(false), ref })
  const current = accounts.find((a) => a.account_id === value)

  return (
    <div className={s.pillSelect} ref={ref}>
      <button
        aria-expanded={open}
        className={s.accountPicker}
        onClick={() => setOpen((v) => !v)}
        type="button"
      >
        <Avatar name={current?.name ?? '?'} />
        <span className={s.accountText}>
          <strong>{current?.name}</strong>
          <small>Ad account ID: {current?.account_id}</small>
        </span>
        <ChevronDown className={s.pillChevron} />
      </button>
      {open && (
        <div className={classNames(s.menu, s.menuLeft)}>
          <div className={s.menuList}>
            {accounts.map((a) => (
              <button
                className={classNames(s.menuItem, s.accountItem, {
                  [s.menuItemActive]: a.account_id === value,
                })}
                key={a.account_id}
                onClick={() => {
                  onChange(a.account_id)
                  setOpen(false)
                }}
                type="button"
              >
                <Avatar name={a.name} />
                <span className={s.accountText}>
                  <strong>{a.name}</strong>
                  <small>Ad account ID: {a.account_id}</small>
                </span>
                {a.account_id === value && <CheckIcon />}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}
